

<script setup>
import MultiButtonModal from '@/components/Alerts/MultiButtonModal.vue'
import { ModalButtonData } from '@/components/Alerts/ModalButtonData.js'
import { ButtonSize, ButtonType } from '@/components/Forms/Buttons/SubmitButtonConstants.js'
import { useSessionTimeout } from '@/composables/useSessionTimeout.js'
import { useAuthStore } from '@/stores/authStore.js'

const authStore = useAuthStore()
const {
	showWarning,
	showExpired,
	timeRemaining,
	resetTimer,
	handleLogout
} = useSessionTimeout(
	{
		sessionDuration: authStore.getAuth?.sessionTimeout(), //JWT_TTL in user service
		//!! If you're testing low timeout numbers, be sure to change buffer/warningTime,
		// Ex use this to warn with 30 seconds left with a 1-minute timeout
		//buffer: 0, warningTime:.75
	})

/**
 * Format the time
 * @param {number} p_ms Milliseconds left on timer before expiration
 * @returns {string} Remaining time formatted
 */
function formatTime (p_ms)
{
	const minutes = Math.floor(p_ms / 60000)
	const seconds = Math.floor((p_ms % 60000) / 1000)
	return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

</script>

<template>
	<MultiButtonModal
		:show="showWarning"
		icon="info"
		title="Session About to Expire"
		:message="`Your session will expire in ${ formatTime(timeRemaining) }. Would you like to continue your session?`"
		:buttons="[
						new ModalButtonData(
							'Yes',
							() => { resetTimer(true) },
							ButtonType.Default,
							ButtonSize.Small
						),
						new ModalButtonData(
							'No',
							handleLogout,
							ButtonType.Default,
							ButtonSize.Small
						),
					]"
	/>

	<Teleport to="html">
		<MultiButtonModal
			:show="showExpired"
			icon="alert"
			title="Session Timeout"
			message="Your session has expired. Please sign in again."
			:buttons="[
							new ModalButtonData(
								'Ok',
								handleLogout,
								ButtonType.Default,
								ButtonSize.Small
							)
						]"
		/>
	</Teleport>

</template>

<style scoped>

</style>